// LIBRERIE
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

//CONFIGURAZIONI
import appConfig from "../../config/appConfig";

const SocialPost: React.FC = () => {

    return(
        <section id="social-post" className="space-ptb">
            <div className="container-fluid w-90">
                <h2 className="asH2SubTitle mb-4 text-center">Seguici sui social e non perderti nulla</h2>
                <div className="row justify-content-center align-items-stretch">
                    <div className="col-12 col-lg-8 text-center">
                        <img className="img-fluid" src="/assets/images/logo.png" alt="logo" />
                        <p className="mt-4 mb-0">Seguici sui nostri <strong>canali social</strong> per restare sempre un passo avanti: scoprirai in anteprima nuove opportunità, consigli pratici per vendere o acquistare casa e aggiornamenti costanti sul mercato.<br/>Entra anche tu dietro le quinte del settore immobiliare e vivilo in modo chiaro e senza filtri!</p>
                    </div>
                    <div className="col-12 col-lg-4">
                        <div className="social-list mt-3 mt-lg-0">
                            <a href={appConfig.socialLinks.instagram} title="Instagram Link" target="_blank" rel="noopener noreferrer">
                                <i className="fa-brands fa-instagram"></i>
                            </a>
                            <a href={appConfig.socialLinks.facebook} title="Facebook Link" target="_blank" rel="noopener noreferrer">
                                <i><FontAwesomeIcon icon={faFacebookF} /></i>
                            </a>
                            <a href={appConfig.socialLinks.whatsapp} title="WhatsApp Link" target="_blank" rel="noopener noreferrer">
                                <i><FontAwesomeIcon icon={faWhatsapp} /></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default SocialPost;